import NumberFormat from "react-number-format";
import InputText from "../text/input";

export default function CurrencyField({
  label,
  value,
  onChange,
  disabled,
}) {
  return (
    <NumberFormat
      prefix="R$ "
      customInput={InputText}
      thousandSeparator="."
      decimalSeparator=","
      allowNegative={false}
      decimalScale={2}
      fixedDecimalScale
      label={label}
      fullWidth
      variant="outlined"
      disabled={disabled}
      value={value}
      onValueChange={onChange}
      onInput={(e) => (e.target.value = e.target.value.toString().slice(0, 20))}
    />
  );
}
